import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "@/assets/styles/fontawesome.min.css";
import "@/assets/styles/solid.min.css";
import "@/assets/styles/bootstrap.min.css";
import "@/assets/styles/master.css";

import goTo from 'vuetify/lib/services/goto';
import VuePageTransition from 'vue-page-transition'

import VueMeta from 'vue-meta';
import VueAddtohomescreen from "@owliehq/vue-addtohomescreen";
import VueGtag from "vue-gtag";
import {toHttps} from "@/seo";

Vue.use(VueAddtohomescreen);
Vue.use(VueMeta);

Vue.use(VuePageTransition)

Vue.prototype.$baseUrl = "https://api.partograd.com/";

Vue.prototype.$replaceHttps = toHttps;

Vue.prototype.$numberWithCommas = function (x) {
  if(x !== null) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

Vue.prototype.$scrollTop = function (x) {
  return goTo(x);
}

Vue.config.productionTip = true;

Vue.use(VueGtag, {
  config: { id: "G-N0M1D95D1J" },
  params: {
    send_page_view: false,
    pageTrackerScreenviewEnabled: true
  },
}, router);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
